﻿import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ApiService } from '../services/api.service';
import notify from 'devextreme/ui/notify';

@Injectable()
export class AuthGuard implements CanActivate {
  notifyOptions: any = {
    'width': 'auto',
    'minWidth': '350px',
    'displayTime': 6000,
    'contentTemplate': 'content'};

  constructor(private authService: AuthService, private router: Router, private apiService: ApiService) { }

  canActivate() {
    return this.isLoggedIn().then((response: any) => {
      if (response.isLoggedIn === 0) {
        this.router.navigate(['/home/login']);
         this.notifyOptions.message = 'Youv\'e been logged out, please re-login';
        notify(this.notifyOptions, 'info');
      }
      return response.isLoggedIn === 1;
  }).catch(function (err) {
      return false;
  });
    // if () {
    //   return true;
    // } else {
    //   this.router.navigate(['/home/login']);
    //   return false;
    // }
  }

  private isLoggedIn(): Promise<any> {
    return this.apiService.get('checkLogin.asp', false);
  }
}
